import { useQueryData } from '@gogame/query';

import { list } from './queryKeyFactory';

export const useCommentsCount = (conceptId) => {
  return useQueryData(list(conceptId), {
    exact: true,
  })?.length;
};
